import React, { useMemo } from 'react';

import { useFieldArray, useFormContext } from 'react-hook-form';

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';

import RefundItemRow from './RefundItemRow';

import { useTranslation } from 'react-i18next';
import type RefundForm from '../../../models/RefundForm';

const RefundItemsTable: React.FC = () => {
    const { t } = useTranslation('refund', {
        keyPrefix: 'PRODUCTS_STEP.PRODUCTS_TABLE',
    });

    const form = useFormContext<RefundForm>();

    const { fields, remove } = useFieldArray({
        control: form.control,
        name: 'products',
    });

    const refundItemsTableHead = useMemo(
        () => [
            t('TABLE_HEAD.PRODUCT'),
            t('TABLE_HEAD.ACCOUNT_IDENTIFIER'),
            t('TABLE_HEAD.ORDERED_AMOUNT'),
            t('TABLE_HEAD.QUANTITY_TO_RETURN'),
            t('TABLE_HEAD.MEASUREMENT_UNIT'),
            null,
        ],
        [t]
    );

    return (
        <TableContainer>
            <Table sx={{ marginBlockEnd: 2 }}>
                <TableHead>
                    <TableRow>
                        {refundItemsTableHead.map((title, key) => (
                            <TableCell key={key}>
                                <Typography>{title}</Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {fields?.map((item, index) => (
                        <RefundItemRow
                            key={item.itemNo}
                            control={form.control}
                            item={item}
                            index={index}
                            onRemove={remove.bind(this, index)}
                        />
                    ))}

                    {fields.length < 1 && (
                        <TableRow>
                            <TableCell colSpan={6}>
                                <Typography textAlign="center">
                                    {t('EMPTY_STATE_TEXT')}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RefundItemsTable;
